import { format, parseISO } from 'date-fns'

import { Vendor } from '@/models/insuranceTypes'
import type { VendorDaySeries } from '@/models/quoteAnalytics'
import { OTHER_COLOR, SERIES_COLORS } from '../AgentReporting/chartPalette'

export enum Outcome {
  ERROR = 'error',
  DECLINED = 'declined',
  UNAVAILABLE = 'unavailable',
  SUCCESS = 'generated',
}

export const OUTCOMES = [
  { value: Outcome.ERROR, label: 'Error' },
  { value: Outcome.DECLINED, label: 'Declined' },
  { value: Outcome.UNAVAILABLE, label: 'Unavailable' },
  { value: Outcome.SUCCESS, label: 'Success' },
]

// Fixed per carrier, so a carrier keeps its color when others drop out of the range.
const CARRIER_ORDER: string[] = [
  Vendor.ROCKLAKE,
  Vendor.GEICO,
  Vendor.COVERWHALE,
  Vendor.CORGI,
  Vendor.NIRVANA,
  Vendor.PROGRESSIVE,
  Vendor.AMWINS,
  Vendor.RYAN_SPECIALTY,
]

export interface Carrier {
  vendor: string
  name: string
  color: string
}

export type ChartRow = Record<string, string | number> & { period: string }

function rank(vendor: string): number {
  const index = CARRIER_ORDER.indexOf(vendor)
  return index === -1 ? CARRIER_ORDER.length : index
}

export function toCarriers(series: VendorDaySeries[]): Carrier[] {
  return [...series]
    .sort((a, b) => rank(a.vendor) - rank(b.vendor))
    .map((s) => ({ vendor: s.vendor, name: s.name, color: SERIES_COLORS[rank(s.vendor)] ?? OTHER_COLOR }))
}

/** One row per day holding the chosen outcome's count for every carrier. */
export function toChartRows(series: VendorDaySeries[], outcome: Outcome): ChartRow[] {
  const days = series[0]?.days ?? []
  return days.map((day, index) => {
    const row: ChartRow = { period: day.period }
    for (const s of series) row[s.vendor] = s.days[index][outcome]
    return row
  })
}

export function formatDay(period: string, long = false): string {
  return format(parseISO(period), long ? 'EEE, MMM d' : 'MMM d')
}
